export default "__VITE_ASSET__1513c76b__"